import * as React from "react";

const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Loans     = React.lazy(() => import("./pages/Loans"));
const Page      = React.lazy(() => import("./pages/EquipmentPage"));
const Shipments = React.lazy(() => import("./pages/Shipments"));
const Shipped   = React.lazy(() => import("./pages/Shipped")); // или InRepair, если файл так называется
const Transfers = React.lazy(() => import("./pages/WarehouseTransfers"));
const RepairQueue = React.lazy(() => import("./pages/RepairQueue"));
const Defective = React.lazy(() => import("./pages/Defective"));

export const EquipmentDashboard = Dashboard;
export const EquipmentLoans     = Loans;
export const EquipmentTsd       = () => <Page table="tsd" />;
export const EquipmentFinger    = () => <Page table="finger_scanners" />;
export const EquipmentDesktop   = () => <Page table="desktop_scanners" />;
export const EquipmentTablets   = () => <Page table="tablets" />;
export const EquipmentPcSets    = () => <Page table="pc_sets" />;
export const EquipmentShipments = Shipments;
export const EquipmentShipped   = Shipped;
export const EquipmentTransfers = Transfers;
export const EquipmentRepairQueue = RepairQueue;
export const EquipmentDefective = Defective;
